<div class="indicator-bar-container">
  <div class="indicator-bar-track">
    <div class="indicator-bar-fill" [ngStyle]="{ width: (percentUsed * 100) + '%', background: barColor }"></div>
  </div>
  <span class="indicator-bar-text">{{displayText}}</span>
</div> 